module.exports = __webpack_public_path__ + "static/54-mobiles-d2e09538f0c7330d581a0c3fa0815587.png";